export const partnerUserInitialValue = {
	auth: {
		access_token: "",
		isAuthenticated: false,
	},
	customer: {
		document: "",
	},
};
